import { USER } from 'constants/store.constants';

const selectUserSlice = (state) => state[USER];
export const selectUsers = (state) => selectUserSlice(state).users;
